import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { type NodeMouseHandler } from '@xyflow/react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { normalizeNodeType } from 'modules/job_catalog/lib/nodesUtils'

import { type CustomNode } from './types'

const useNodeNavigation = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const onNodeClick: NodeMouseHandler<CustomNode> = useCallback(
    (_, node: CustomNode) => {
      track(trackingEvents.jobCatalog.openNodeSidebarSubmit, {
        event_category: 'Organizations',
        node_type: normalizeNodeType(node.data.type),
        node_id: node.id,
        node_name: node.data.name,
      })
      navigate(navigation.employees.jobCatalog.overview.node.fullPath({ id: node.id }))
    },
    [navigate, navigation]
  )

  return { onNodeClick }
}

export default useNodeNavigation
